// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","caption":"CaptionMultylines_caption__3FaEv sharedStyles_standardTextStructure__2HVr-"};